import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Textarea from '../../../components/elements/form/textarea';
import { useParams } from 'react-router-dom';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../_common/constant';
import moment from 'moment';
import { showDate, showLocalDate, showLocalDateTime, showLocalTime } from '../../../_common/functions';
import { useWorkRequestApi } from '../../../store/api/hooks/workRequestApiHook';

interface Note {
  id: number;
  content: string;
}

interface NotesProps {
  canAddNotes?: boolean;
}

const Notes: React.FC<NotesProps> = ({ canAddNotes = true }) => {
  const params: any = useParams();
  const assetsAPI = useAssetsApi();
  const workRequestAPI: any = useWorkRequestApi();
  const [notes, setNotes] = useState<Note[]>([]);
  const { showLoader, hideLoader } = useAppLoader();
  const { control, reset, handleSubmit, formState: { errors } } = useForm<any>();

  const addNote = (value: any) => {
    if (!canAddNotes) {
      toast.error("You don't have permission to add notes");
      return;
    }

    const payload = {
      "objRequestModel": [
        {
          "workRequestNote": value.notes,
          "workRequestID": params.id
        }
      ]
    }

    showLoader();
    workRequestAPI.SaveWorkRequestNotes(payload, (data: any) => {
      hideLoader();
      clearnote();
      getNotesList(params.id);
      toast.success("Notes Added Successfully");
    }, (error: any) => {
      hideLoader();
    });
  };

  const deleteNote = (id: number) => {
    setNotes(notes.filter(note => note.id !== id));
  };
  const clearnote = () => {
    if (!canAddNotes) {
      toast.error("You don't have permission to add notes");
      return;
    }
    reset({ 'notes': '' });
  }

  const getNotesList = (assetID: any) => {
    const payload = {
      workRequestID: assetID
    }
    showLoader();
    workRequestAPI.GetWorkRequestNotesList(payload, (data: any) => {
      hideLoader();
      if (data.workRequestNotesList) {
        setNotes(data.workRequestNotesList);
      } else {
        setNotes([]);
      }

    }, (error: any) => {
      hideLoader();
    });
  };

  useEffect(() => {
    if (params.id) {
      getNotesList(params.id);
    }
  }, [params]);

  return (
    <div className={`mt-3`}>
      {/* <div className='flex justify-between border-b border-gray-200 items-center py-2 mb-3'>
            <h4 className='font-semibold text-[0.938rem] py-4'>Write Your Notes Here</h4> 
            <button className='bg-white border border-gray-400 text-black text-sm px-5 py-3 rounded-md font-bold hover:bg-[#f3f3f3] shadow-md'> ⋮ </button>
          </div> 
      */}
      <div className={`flex items-center justify-between py-2 mb-0`}>
        <h4 className={`py-2 pl-1`} style={{ color: `#000`, fontWeight: `bold`, fontSize: 15 }}>Notes</h4>
      </div>
      <form className="w-full" onSubmit={handleSubmit(addNote)}>
        <Controller
          name='notes'
          control={control}
          rules={{ required: 'Notes required' }}
          render={({ field: { value, onChange } }) => (
            <Textarea
              label={''}
              value={value}
              onChange={onChange}
              className={`!my-0`}
              mainElementClassName={`!mt-0 !w-full`}
              placeholder='Write Your Notes'
              error={errors?.notes?.message as any}
              disabled={!canAddNotes}
            />
          )}
        />
        <div className='flex justify-end pb-4 gap-3 mt-2'>
          <button 
            type='submit' 
            disabled={!canAddNotes}
            className={`${!canAddNotes ? 'bg-gray-400 border-gray-400 cursor-not-allowed' : 'bg-success border border-success hover:bg-[#666666] hover:border-[#666666]'} text-white text-sm px-8 py-2 rounded-md font-medium`} 
            style={{ width: 111, height: 40 }}
          >
            Add
          </button>
          <button 
            type='button' 
            onClick={clearnote} 
            disabled={!canAddNotes}
            className={`${!canAddNotes ? 'bg-gray-400 border-gray-400 cursor-not-allowed' : 'bg-secondary border border-secondary hover:bg-[#7b5f54] hover:border-[#7b5f54]'} text-white text-md px-6 py-2 rounded-md font-medium`} 
            style={{ width: 110, height: 40 }}
          >
            Clear
          </button>
        </div>
      </form>

      <ul className='px-3 py-3 bg-gray-50 rounded-md border border-gray-300 max-h-[25.25rem] overflow-y-scroll'>
        {notes.length === 0 && <div className='flex justify-center items-center text-black font-semibold'> No Record's Found</div>}
        {notes?.map((note: any) => (
          <li className='text-[#323233] text-[0.938rem]'>
            <p className='p-5 bg-gray-100 rounded-md border border-gray-300' style={{ minHeight: 125 }}>{note?.workRequestNote}</p>
            <div className='flex justify-end mt-2 mb-4' style={{ color: `#000000` }}>By: {note?.addedByName} on {showLocalDateTime(note?.addedDate)}  </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Notes;